import React from "react";
import { Menu, ChevronRight } from "lucide-react";

export default function SidebarToggle({ collapsed, onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-900 transition-colors focus:outline-none focus:ring-2 focus:ring-[#7C3AED]/20"
      aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      data-testid="sidebar-toggle"
    >
      {collapsed ? (
        <ChevronRight className="w-5 h-5 transition-transform duration-200" />
      ) : (
        <Menu className="w-5 h-5 transition-transform duration-200" />
      )}
    </button>
  );
}
